import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'PLAN_SETTINGS/DISCOUNTS/GROUPS';

export const {action: addSession} = createAction(`${domain}/ADD_SESSION`, (session, successData) => ({
    session,
    successData,
}));

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {
    action: fetchAllSessions,
    success: fetchAllSessionsSuccess,
    failed: fetchAllSessionsFailed,
} = createAction(
    `${domain}/FETCH_ALL_SESSIONS`,
    institutionId => ({institutionId}),
    sessionVersions => ({sessionVersions}),
);

export const {action: removeSessionFromGroup} = createAction(
    `${domain}/REMOVE_SESSION`,
    (fields, index, groupIndex) => ({fields, index, groupIndex}),
);

export const {
    action: updateSessionDiscountVolumeGroups,
    success: updateSessionDiscountVolumeGroupsSuccess,
    failed: updateSessionDiscountVolumeGroupsFailed,
    aborted: updateSessionDiscountVolumeGroupsAborted,
} = createAction(
    `${domain}/UPDATE_SESSION_DISCOUNT_VOLUME_GROUPS`,
    (institutionId, discountVolumeGroups, pricingGroups) => ({institutionId, discountVolumeGroups, pricingGroups}),
);

export const {action: addDiscountGroupToForm} = createAction(`${domain}/ADD_DISCOUNT_GROUP_TO_FORM`, name => ({name}));

export const {action: addVolumeToGroup} = createAction(`${domain}/ADD_VOLUME_TO_GROUP`, name => ({name}));

export const {action: showRemoveGroupFromForm} = createAction(
    `${domain}/SHOW_REMOVE_GROUP_FROM_FORM`,
    (show, group, index, groupToDelete) => ({show, group, index, groupToDelete}),
);

export const {action: removeGroupFromForm, aborted: removeGroupFromFormAborted} = createAction(
    `${domain}/REMOVE_GROUP_FROM_FORM`,
    (group, index, institutionId, groupToDelete, validFrom) => ({
        group,
        index,
        institutionId,
        groupToDelete,
        validFrom,
    }),
);
